import { styled } from 'styled-components';

import { theme } from '@/shared/theme';
import { mq } from '@/shared/ui/styled';

export const StyledEmptyBasketWrapper = styled.div`
    margin-top: 64px;
    margin-bottom: 106px;

    .content {
        display: flex;
        flex-direction: column;
        align-items: center;

        .ico {
            margin-bottom: 31px;
        }

        .title1 {
            font-style: normal;
            font-weight: 500;
            font-size: 20px;
            line-height: 120%;
            color: ${theme.color.dark};
            margin-bottom: 8px;
        }

        .title2 {
            text-align: center;
        }

        .button {
            margin-top: 24px;

            a {
                svg {
                    margin-right: 5px;
                }
            }
        }
    }
`;

export const StyledBasketFullWrapper = styled.div`
    .head {
        margin-top: 16px;
        margin-bottom: 16px;
        display: flex;
        align-items: center;
        padding: 16px 32px;
        background-color: #fff;
        justify-content: space-between;
        height: 85px;
        border-radius: 12px;
        row-gap: 16px;
        ${mq.lt.md} {
            height: auto;
            justify-content: start;
            align-items: start;
            flex-direction: column-reverse;

            .inf2 {
                svg {
                    margin-right: 24px;
                }
            }
        }

        .inf1 {
            display: flex;
            align-items: center;
            width: 447px;
            font-style: normal;
            font-weight: 400;
            font-size: 16px;
            line-height: 120%;
            margin-right: 10px;
            ${mq.lt.md} {
                width: 100%;
            }

            > span {
                margin-right: 32px;
            }
        }

        .inf2 {
            font-style: normal;
            font-weight: 500;
            font-size: 14px;
            line-height: 130%;

            ${mq.lt.md} {
                > div {
                    display: flex;
                    align-items: center;
                }
            }

            > span {
                font-weight: 700;
            }
        }
    }
`;

export const StyledBasketPageModuleLoader = styled.div`
    margin-top: 54px;
    display: flex;
    align-items: center;
    justify-content: center;
`;

export const BasketIsAllowedBlockWrapper = styled.div`
    display: flex;
    align-items: center;
    margin-top: 16px;
    margin-bottom: 16px;
    padding: 16px 32px;
    background-color: #fff;
    min-height: 85px;
    border-radius: 12px;

    ${mq.lt.md} {
        height: auto;
    }

    .text {
        display: flex;
        align-items: center;
        height: 100%;
        max-width: 820px;
    }

    .smile {
        margin-left: 16px;
        margin-right: 24px;
        font-size: 42px;
    }
`;
